// extracted by mini-css-extract-plugin
export default {"icon":"Info_icon__sNq1C"};